import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=3694a532&scoped=true&"
import script from "./ColorBar.vue?vue&type=script&lang=js&"
export * from "./ColorBar.vue?vue&type=script&lang=js&"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=3694a532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694a532",
  null
  
)

export default component.exports